import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

const Favicon = (favicon) => {
  const link = document.querySelector("link[rel~='icon']");
  if (link) {
    link.href = favicon;
  } else {
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = favicon;
    document.head.appendChild(newLink);
  }
};

export const FaviconUpdater = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const param = searchParams.get("auth");

  useEffect(() => {
    let favicon = "assets/icons/favicon.ico";

    if (pathname.startsWith("/dashboard") || pathname.startsWith("/assign")) {
      favicon = "/assets/icons/teach_assign.ico";
    } else if (
      pathname.startsWith("/create/") ||
      pathname.startsWith("/createbook")
    ) {
      favicon = "/assets/icons/create.ico";
    } else if (pathname.startsWith("/student") || param === "student") {
      favicon = "/assets/icons/learn.ico";
    }

    Favicon(favicon);
  }, [pathname, param]);

  return null;
};
